<template>
  <AdminShell>
    <div class="head">
      <h2>Flows</h2>
      <router-link to="/admin/flows/new" class="btn">Create Flow</router-link>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Tenant</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="f in flows" :key="f.id">
          <td>{{ f.name }}</td>
          <td>{{ f.tenant_name || "-" }}</td>
          <td>{{ f.is_active ? "Yes" : "No" }}</td>
        </tr>
      </tbody>
    </table>
  </AdminShell>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AdminShell from "@/components/admin/AdminShell.vue";
import { getFlows } from "@/services/admin";

const flows = ref([]);

onMounted(async () => {
  const res = await getFlows();
  flows.value = res.data?.flows || [];
});
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.btn {
  background: #8b5cf6;
  color: #fff;
  text-decoration: none;
  padding: 10px 14px;
  border-radius: 10px;
}
.table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}
th, td {
  padding: 12px;
  border-bottom: 1px solid #eee;
}
</style>
